let locale = {};
export function setLocale(value) {
  locale = Object.assign({}, value);
}
export function getLocale() {
  return locale;
}
